import { ICurrencyOptionsData } from '@modules/accounting-and-finance/interface/forex.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ICurrencyOptionsData[] = [];

export const ACCGCurrencyOptionsSlice = createSlice({
  name: 'accgCurrencyOptions',
  initialState,
  reducers: {
    setACCGCurrencyOptions: (
      _state,
      action: PayloadAction<ICurrencyOptionsData[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGCurrencyOptions: () => {
      return initialState;
    },
  },
});

export default ACCGCurrencyOptionsSlice.reducer;

export const { setACCGCurrencyOptions, removeACCGCurrencyOptions } =
  ACCGCurrencyOptionsSlice.actions;
